import { ref } from 'vue'
import { defineStore } from 'pinia'

const useDeviceManagementTokenStore = defineStore('deviceManagementTokenStore', () => {
  const accessToken = ref<string>()

  return {
    accessToken
  }
})

export { useDeviceManagementTokenStore }
